import { render, staticRenderFns } from "./HistoricalPlans.vue?vue&type=template&id=a006af66&"
import script from "./HistoricalPlans.vue?vue&type=script&lang=js&"
export * from "./HistoricalPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports